<template>
  <div class="loto" :class="{ lotovert: $route.meta.isGame === 'loto-vert' }">
    <Loading v-if="lotoLoading"></Loading>
    <div v-else>
      <div
        v-if="
          ($route.meta.isGame === 'loto' && configGame[0].enabled) ||
          ($route.meta.isGame === 'loto-vert' && configGame[1].enabled) ||
          ($route.meta.isGame === 'loto-plus' && configGame[2].enabled)
        "
      >
        <div class="loto__wrap">
          <div class="loto__top">
            <div class="loto__top--title">
              <h2>{{ getTranslatedText(nameGame) }}</h2>
            </div>
            <div class="loto__top--radio">
              <div>
                <input
                  type="radio"
                  id="grid_v"
                  name="radioView"
                  :value="false"
                  v-model="viewNumber"
                />
                <label for="grid_v" @click="setPlayBlockGame('playblock_grid_view')">
                  <span class="checkmark"></span>
                  {{ getTranslatedText("grid view") }}
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  id="numbers_v"
                  name="radioView"
                  :value="true"
                  v-model="viewNumber"
                />
                <label for="numbers_v" @click="setPlayBlockGame('playblock_numbers_view')">
                  <span class="checkmark"></span>
                  {{ getTranslatedText("numbers view") }}
                </label>
              </div>
            </div>
          </div>
          <div class="loto__content">
            <p class="loto__content--title">
              {{ getTranslatedText("select draw date") }}
            </p>
            <div class="loto__content--wrap">
              <ul class="loto__content--item draw_date">
                <template v-for="(item, index) in drawDate">
                  <li
                  :key="index"
                  @click="handleSelectDate(item)"
                  :class="{ active: selectedDate === item }"
                >
                  <span>{{ item.draw_date_str }}</span>
                </li>
                </template>
              </ul>
            </div>
          </div>
          <div class="loto__content" v-if="dataGame?.markets.some(game => game.odds > 0)">
            <p class="loto__content--title">
              {{ getTranslatedText("Regular Draw") }}
            </p>
            <div class="loto__content--wrap">
              <ul class="loto__content--item regular_draw">
                <template v-for="(item, index) in dataGame?.markets">
                  <li
                    v-if="item.odds > 0"
                    :key="index"
                    @click="handleRegularDraw(item)"
                    :class="{ active: selectedReguar === item }"
                  >
                    <span>{{ getTranslatedText(item.market_name) }}</span
                    ><span>{{ renderPrice(item.odds) }}</span>
                  </li>
                </template>
              </ul>
            </div>
            <p class="loto__content--title">
              {{ getTranslatedText("Select Numbers") }}
            </p>
            <div class="loto__content--wrap">
              <div class="loto__content--button">
                <ButtonCommon
                  :isNoHover="true"
                  text="Quick Pick"
                  @action-button="quickPickNumber"
                  type=""
                />
              </div>
              <ul v-if="!viewNumber" class="loto__content--select">
                <template v-for="(number, index) in endNumber">
                  <li
                    :key="index"
                    :class="{ active: selectedNumber.includes(number) }"
                    @click="handleSelectNumber(number)"
                    v-if="number >= starNumber"
                  >
                    {{ number }}
                  </li>
                </template>
              </ul>
              <div class="loto__numberView" v-else>
                <p class="loto__numberView--error">{{ getTranslatedText(mesErrorNumber) }}</p>
                <div class="loto__numberView--content" v-if="selectedReguar">
                  <input
                    type="text"
                    v-for="(item, index) in numberSelected"
                    :key="index"
                    v-model="selectedNumber[index]"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    @input="checkNumberView($event, index)"
                    @click="checkNumberView($event, index)"
                    :class="{ input_error: item.numberError}"
                  />
                </div>
                <div class="loto__numberView--empty" v-else>
                  {{ getTranslatedText("Please select regular draw") }}
                </div>
              </div>
            </div>
          </div>
          <template v-if="dataOtherDraw && dataOtherDraw.length > 0">
            <div class="loto__content" v-for="(item, index) in dataOtherDraw" :key="index">
              <p class="loto__content--title" >
                {{ item?.market_name }}
              </p>
              <div class="loto__content--wrap">
                <ul class="loto__content--item other_draw">
                  <template v-for="(e, id) in item.games">
                    <li
                      :key="id"
                      @click="handleSelectOtherDraw(e)"
                      :class="{ active: selectedOtherDraw.includes(e) }"
                    >
                      <span>{{ getTranslatedText(e?.name) }}</span
                      ><span>{{ e?.odds }}</span>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </template>
          <div class="loto__content" v-if="dataTotalValue && dataTotalValue.length > 0">
            <p class="loto__content--title">
              {{ getTranslatedText("Total Value") }}
            </p>
            <div class="loto__content--wrap">
              <ul class="loto__content--item total_value">
                <li
                  v-for="(item, id) in dataTotalValue"
                  :key="id" @click="handleSelectTotalValue(item)"
                  :class="{ active: selectTotalValue === item }"
                >
                  <span>{{item?.name}}</span><span>{{ item?.odds }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="loto__button">
          <ButtonCommon
            :isNoHover="true"
            text="Clear"
            @action-button="handleClear()"
            className="loto_clear"
          />
          <ButtonCommon
            :isNoHover="true"
            text="Add"
            @action-button="checkAddBetslip()"
            className="loto_add"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import errorDeviceMinxins from "@/mixins/errorDevice/errorDevice-mixins";
import configGameMinxins from "@/mixins/configGame/configGame-mixins";
import ButtonCommon from "@/components/common/button";
import EventBus from "@/utils/EventBus";
import GamesService from "@/services/games.service";
import { formatPrice } from "@/utils/utils";
import {getUserInfo, setUserInfo} from '@/services/axios'
import Loading from "@/components/common/loading";

export default {
  mixins: [languageMixins, errorDeviceMinxins, configGameMinxins],
  components: { ButtonCommon, Loading },
  data() {
    return {
      viewNumber: false,
      nameGame: "",
      selectedDate: null,
      selectedReguar: null,
      selectedNumber: [],
      numberMaxSelected: 0,
      numberMinSelected: 0,
      starNumber: 0,
      endNumber: 0,
      drawDate: [],
      dataGame: {},
      dataQuickPick: {},
      dataAddBetslip: [],
      lotoLoading: false,
      mesErrorNumber: false,
      numberSelected:[],
      TIME_ZONE: process.env.VUE_APP_TIME_ZONE,
      dataTotalValue: [],
      dataOtherDraw:[],
      selectedOtherDraw: [],
      selectTotalValue:null
    };
  },
  created() {
    this.fetchData();
    this.$store.dispatch('fetchDataConfig').then((res) => {
      this.checkErrorDevice(this.$router, res)
    }).catch((err)=>{
      this.checkErrorDevice(this.$router, err)
    })
    if (this.$route.meta?.isGame === 'loto' && !this.configGame[0]?.enabled
      || this.$route.meta?.isGame === 'loto-vert' && !this.configGame[1]?.enabled
      || this.$route.meta?.isGame === 'loto-plus' && !this.configGame[2]?.enabled) {
        this.$router.push({name: 'Home'})
      }
    this.checkPlayblock();
  },
  computed: {
    dataUserInfo() {
      return this.$store.state.userInfo
      ? this.$store.state.userInfo
      : getUserInfo() ? JSON.parse(getUserInfo()) : null
    }
  },
  watch: {
    $route(to, from) {
      this.fetchData();
    },
    selectedNumber(){
      if(this.viewNumber){
        this.isvalidateNumber();
      }
    },
    viewNumber(){
      if(this.mesErrorNumber){
        this.selectedNumber = [];
      }
    }
  },
  methods: {
    async fetchData() {
      this.handleClear();
      try {
        this.lotoLoading = true;
        await Promise.all([this.fetchDraws(), this.fetchGames()]);
        this.lotoLoading = false;
      } catch (error) {
        console.log(error);
        this.lotoLoading = false;
      }
    },
    async fetchDraws() {
      try {
        let gameDraw = "";
        if (this.$route.meta.isGame === 'loto') {
          gameDraw = this.slugGames[0];
        } else if(this.$route.meta.isGame === 'loto-vert') {
          gameDraw = this.slugGames[1];
        } else {
          gameDraw = this.slugGames[2];
        }
        const res = await GamesService.getDrawGames(gameDraw);
        if (res.status === "success") {
          this.drawDate = res.data;
        } else {
          console.log(res);
        }
        this.checkErrorDevice(this.$router, res);
      } catch (error) {
        console.log(error);
        this.checkErrorDevice(this.$router, error);
      }
    },
    async fetchGames() {
      try {
        const res = await GamesService.getListGame();
        if (res.status === "success") {
          if (this.$route.meta.isGame === 'loto') {
            this.handleCheckDataGame(res.data, 0);
          } else if (this.$route.meta.isGame === 'loto-vert') {
            this.handleCheckDataGame(res.data, 1);
          } else {
            this.handleCheckDataGame(res.data, 2);
          }
          let otherDraw = (this.dataGame?.markets || [])
            .filter(item => item?.odds === 0 && item?.market_slug !== 'totalvalue')
            .map(e => ({
              games: Object.entries(e?.config?.outcomes || {}).map(([key,x]) => ({
                ...x,
                market_id: e.market_id,
                key: key,
              })),
              market_name: e.market_name,
            }));
          this.dataOtherDraw = otherDraw ? otherDraw.flat() : [];

          let totalValue = this.dataGame?.markets.find((item) => item?.market_slug === 'totalvalue');
          totalValue = Object.entries(totalValue?.config?.outcomes || {}).map(([key, value]) => ({
            ...value,
            market_id: totalValue.market_id,
            key: key
          }));
          this.dataTotalValue = totalValue ? totalValue : [];

          this.nameGame = this.dataGame?.game?.name;
          if (this.dataGame?.game?.config?.setup[1]) {
            this.setupQuickPick(this.dataGame?.game?.config?.setup[1]);
          }
        } else {
          console.log(res);
        }
        this.checkErrorDevice(this.$router, res);
      } catch (error) {
        console.log(error);
        this.checkErrorDevice(this.$router, error);
      }
    },
    handleCheckDataGame(data, id) {
      this.dataGame = data.find(
        (e) => e.game && e.game.slug === this.slugGames[id]
      );
      if (this.dataGame) {
        this.dataGame.markets = this.dataGame?.markets.filter(
          (item) =>
            !this.configGame[id]?.disabled_markets.includes(item.market_slug)
        );
      }
    },
    handleSelectDate(item) {
      if (item === this.selectedDate) {
        this.selectedDate = null
      } else {
        this.selectedDate = item;
      }
    },
    handleRegularDraw(item) {
      if (item === this.selectedReguar) {
        this.selectedReguar = null
      } else {
        this.selectedReguar = item;
        this.numberMaxSelected = item.config.balls[1].picks[1];
        this.numberMinSelected = item.config.balls[1].picks[0];
        this.selectedNumber = [];
        this.numberSelected = [];
        for (let i = 0; i < this.numberMaxSelected; i++) {
          this.numberSelected.push({
            value:undefined,
            numberError:false
          })
        }
        this.mesErrorNumber = false;
      }
    },
    handleSelectNumber(number) {
      if (this.selectedNumber.includes(number)) {
        this.selectedNumber = this.selectedNumber.filter((n) => n !== number);
      } else {
        if (this.selectedNumber.length < this.numberMaxSelected) {
          this.selectedNumber.push(number);
        }
      }
    },
    handleSelectOtherDraw(item) {
      const findItem = this.selectedOtherDraw.findIndex(e => e?.market_id === item?.market_id && e?.key === item?.key);
      const findTypeGame = this.selectedOtherDraw.findIndex(e => e?.market_id === item?.market_id);
      if (findItem !== -1) {
        this.selectedOtherDraw.splice(findItem, 1)
      } else if (findTypeGame !== -1) {
        this.selectedOtherDraw.splice(findTypeGame, 1);
        this.selectedOtherDraw.push(item);
      } else {
        this.selectedOtherDraw.push(item);
      }
    },
    handleSelectTotalValue(item) {
      if (item === this.selectTotalValue) {
        this.selectTotalValue = null;
      } else {
        this.selectTotalValue = item;
      }
    },
    quickPickNumber() {
      const indices = [];
      while (indices.length < this.numberMinSelected) {
        const index =
          Math.floor(Math.random() * (this.endNumber - this.starNumber + 1)) +
          this.starNumber;

        if (!indices.includes(index)) {
          indices.push(index);
        }
      }
      this.selectedNumber = indices;
      this.numberSelected.forEach((item) =>{
        item.numberError = false;
      })
      this.mesErrorNumber = false;
    },
    setupQuickPick(params) {
      this.dataQuickPick = {
        ...params,
        ballset: JSON.parse(params.ballset),
      };

      if (params.is_bonus) {
        this.numberMaxSelected = Number(params.picks) + 1;
      } else {
        this.numberMaxSelected = params.picks;
      }
      this.starNumber = this.dataQuickPick.ballset[0];
      this.endNumber = this.dataQuickPick.ballset[1];
    },
    checkNumberView(event,index) {
      let value = event.target.value.replace(/\D/g, "");
      if(value ===""){
        this.selectedNumber.splice(index,1)
        this.numberSelected[index].value = undefined;
      }else{
        this.selectedNumber[index] = Number(value);
      }
        this.numberSelected[index].value = this.selectedNumber[index];
    },
    isvalidateNumber(){
      const countMap = new Map();
      this.selectedNumber.forEach((item) => {
        countMap.set(item, (countMap.get(item) || 0) + 1);

      });

      this.numberSelected.forEach((item,index)=>{
        item.numberError = false;
        item.value = this.selectedNumber[index];
        const count = countMap.get(item.value);
        if(item.value !=="" && item.value  > this.endNumber){
          item.numberError = `Max is ${this.endNumber}`;
        }else if(item.value !=="" && item.value < this.starNumber){
          item.numberError = `Min is ${this.starNumber}`;
        }else if(count > 1){
          item.numberError = `This value already exists`;
        }

      })
      this.mesErrorNumber = this.numberSelected.find(item=>item.numberError !== false)?.numberError;
    },

    checkAddBetslip() {
      const validateNumber = this.numberSelected.every((item) => item.numberError === false);
      const filterNumber = [...this.selectedNumber].filter((value) => typeof value !== 'undefined');
      let param = {
        status: "error",
        description: "",
      };
      const checkGameRegular = () => {
        if (!this.selectedNumber.length) {
          param.description = "Please select numbers";
        } else if (filterNumber.length < this.numberMinSelected) {
          param.description = `Please select at least ${this.numberMinSelected} numbers`;
        } else if (this.viewNumber && !validateNumber) {
          param.description = "Invalid Input Value"
        }

      }
      if (!this.selectedDate) {
        param.description = "Please select draw date";
      } else if (!this.selectedReguar && !(this.selectedOtherDraw && this.selectedOtherDraw.length > 0) && !this.selectTotalValue) {
        param.description = "Please choose any game";
      } else if (this.selectedReguar) {
        checkGameRegular();
      }
      if (!param.description) {
        this.addBetslip();
        return;
      }
      EventBus.$emit("on-show-notications", param);
    },
    addBetslip() {
      const dataAddToBetslip = {
        draw_date: this.selectedDate.draw_date,
        draw_name: this.selectedDate.draw_name,
        cutoff: this.selectedDate.cutoff,
        event_id: this.selectedDate.event_id,
        error_Bet: false,
        itemError: false,
        itemErrorCutoff: false,
        game: this.dataGame.game,
      };

      if (this.selectedReguar) {
        this.addRegularDrawToBetslip(dataAddToBetslip);
      }

      if (this.selectedOtherDraw && this.selectedOtherDraw.length > 0) {
        this.addOtherDrawsToBetslip(dataAddToBetslip);
      }

      if (this.selectTotalValue) {
        this.addTotalValueToBetslip(dataAddToBetslip);
      }

      this.$store.dispatch("addToBetslip", this.dataAddBetslip);

      this.resetData();
    },

    addRegularDrawToBetslip(dataAddToBetslip) {
      const { selectedReguar } = this;
      if (!selectedReguar) return;

      const reguarDrawAddToBetslip = {
        ...dataAddToBetslip,
        draw_Reguar: selectedReguar,
        selected_numbers: this.selectedNumber,
        potential_winings: selectedReguar?.config?.wager?.min * selectedReguar?.odds,
        regualName: selectedReguar?.market_name,
        odds: selectedReguar?.odds,
        betAmount: selectedReguar?.config?.wager?.min,
        max: selectedReguar.config?.wager?.max,
        min: selectedReguar.config?.wager?.min,
        roundedNumber: selectedReguar.config?.wager?.incremental,
        market_slug: selectedReguar?.market_slug,
      };

      this.dataAddBetslip.push(reguarDrawAddToBetslip);
    },

    addOtherDrawsToBetslip(dataAddToBetslip) {
      this.selectedOtherDraw.forEach(item => {
        const gameOtherDraw = this.dataGame?.markets.find(e => e?.market_id === item.market_id);
        if (!gameOtherDraw) return;

        const otherDrawAddToBetslip = {
          ...dataAddToBetslip,
          potential_winings: gameOtherDraw?.config?.wager?.min * item?.odds,
          regualName: gameOtherDraw?.market_name,
          odds: item?.odds,
          betAmount: gameOtherDraw?.config?.wager.min,
          max: gameOtherDraw?.config?.wager?.max,
          min: gameOtherDraw?.config?.wager?.min,
          roundedNumber: gameOtherDraw?.config?.wager?.incremental,
          market_slug: gameOtherDraw?.market_slug,
          selected_game: item,
        };

        this.dataAddBetslip.push(otherDrawAddToBetslip);
      });
    },

    addTotalValueToBetslip(dataAddToBetslip) {
      const { selectTotalValue } = this;
      if (!selectTotalValue) return;

      const gameTotalValue = this.dataGame?.markets.find(e => e?.market_id === selectTotalValue.market_id);
      if (!gameTotalValue) return;

      const totalvalueAddToBetslip = {
        ...dataAddToBetslip,
        potential_winings: gameTotalValue?.config?.wager?.min * selectTotalValue?.odds,
        regualName: gameTotalValue?.market_name,
        odds: selectTotalValue?.odds,
        betAmount: gameTotalValue?.config?.wager?.min,
        max: gameTotalValue?.config?.wager?.max,
        min: gameTotalValue?.config?.wager?.min,
        roundedNumber: gameTotalValue?.config?.wager?.incremental,
        market_slug: gameTotalValue?.market_slug,
        selected_game: selectTotalValue,
      };

      this.dataAddBetslip.push(totalvalueAddToBetslip);
    },

    resetData() {
      this.dataAddBetslip = [];
      this.selectedOtherDraw = [];
      this.selectTotalValue = null;
      this.selectedNumber = [];
      this.selectedReguar = null;
    },
    renderPrice(price) {
      return formatPrice(price);
    },
    handleClear() {
      this.selectedNumber = [];
      this.selectedReguar = null;
      this.selectedDate = null;
      this.selectTotalValue = null;
      this.selectedOtherDraw = [];
      this.mesErrorNumber = false;
    },
    checkPlayblock(){
      if(this.dataUserInfo?.playblock_method === "playblock_numbers_view"){
        this.viewNumber = true;
      }else if(this.dataUserInfo?.playblock_method === "playblock_grid_view"){
        this.viewNumber = false;
      }
    },
    async setPlayBlockGame(data){
      try{
        const res = await GamesService.setBlockGame(data);
        if(res.status === "success"){
          this.dataUserInfo.playblock_method = data;
          setUserInfo(this.dataUserInfo)
        }else{
          console.log(res.data)
        }
        this.checkErrorDevice(this.$router, res);
      }catch(error){
        console.log(error)
        this.checkErrorDevice(this.$router, error);
      }
    },
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/loto/_index.scss";
</style>
